import React from 'react';
import { Helmet } from 'react-helmet';
import './css/globals.css';
import './css/contact.css';
import './css/header.css';
import './css/footer.css';
import './css/page.css';
import Header from './sections/Header';
import Footer from './sections/Footer';
import Banner from './sections/Banner';
import Cta from './sections/Cta';
import Section1 from './sections/Section1';
import Section2 from './sections/Section2';
import Section3 from './sections/Section3';
import Section4 from './sections/Section4';
import Section5 from './sections/Section5';
import Section6 from './sections/Section6';
import Section7 from './sections/Section7';
import Section8 from './sections/Section8';

const Homepage = () => {

const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Imperial PDG',
    'description': 'Dependable plumbing professionals trusted by Gold Coast residents. Rely on us to resolve all your domestic and commercial plumbing issues promptly and effectively',
    'url': 'https://imperialpdg.com.au/',
    'telephone': '1300631226',
    'logo': 'https://imperialpdg.com.au/img/Imperial%20PDG%20logo%20colored.webp',
    'image': 'https://imperialpdg.com.au/img/imperial-pdg-banner-image.webp',
    'address': {
        '@type': 'PostalAddress',
        'addressLocality': 'Gold Coast',
        'addressRegion': 'QLD',
        'postalCode': '4217',
        'streetAddress': 'PO Box 4916',
        'addressCountry': 'AU'
    },
    'geo': {
      '@type': 'GeoCoordinates',
      'latitude': -28.01294080513038,
      'longitude': 153.40505834857066
    },
    };

    const webPageSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      'name': "Imperial PDG | Gold Coast Plumbers — Hot Water, Water Filters & More",
      'description': 'Dependable plumbing professionals trusted by Gold Coast residents for hot water systems, water filter installation, plumbing maintenance, leaks, and bathroom & kitchen plumbing.',
      'url': 'https://imperialpdg.com.au/',
      'image': {
        '@type': 'ImageObject',
        'url': 'https://imperialpdg.com.au/img/imperial-pdg-banner-image.webp',
        'width': 1900,
        'height': 722
      },
      'breadcrumb': {
        '@type': 'BreadcrumbList',
        'itemListElement': [
          { '@type': 'ListItem', 'position': 1, 'item': { '@id': 'https://imperialpdg.com.au/', 'name': 'Home' } }
        ]
      }
    };

    return (
    <>
        <Helmet>
        <title>Imperial PDG | Gold Coast Plumbers — Hot Water, Water Filters & More</title>
        <meta name="description" content="Dependable plumbing professionals trusted by Gold Coast residents. Hot water systems, water filter installation, plumbing maintenance, leaks, and bathroom & kitchen plumbing. Call 1300 631 226." />
        <meta name="keywords" content="plumber gold coast, hot water systems gold coast, water filter installation gold coast, plumbing maintenance gold coast, imperial pdg" />
        <link rel="canonical" href="https://imperialpdg.com.au/" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Imperial PDG | Gold Coast Plumbers — Hot Water, Water Filters & More" />
        <meta property="og:description" content="Trusted Gold Coast plumbers for hot water systems, whole-home water filtration, leaks, and more. Licensed, local, and reliable." />
        <meta property="og:url" content="https://imperialpdg.com.au/" />
        <meta property="og:site_name" content="Imperial PDG" />
        <meta property="og:image" content="https://imperialpdg.com.au/img/imperial-pdg-banner-image.webp" />
        <meta property="og:locale" content="en_AU" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Imperial PDG | Gold Coast Plumbers" />
        <meta name="twitter:description" content="Trusted Gold Coast plumbers for hot water systems, whole-home water filtration, leaks, and more." />
        <meta name="twitter:image" content="https://imperialpdg.com.au/img/imperial-pdg-banner-image.webp" />

        <script type="application/ld+json">{JSON.stringify(schema)}</script>
        <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
        </Helmet>

    <div className='homepage'>

      <Header />
      <Banner 
        backgroundImg={"/img/imperial-pdg-banner-image.webp"}
        backgroundAltText={"Plumber walking into high-end Gold Kitchen with a tool bag"}
        title={"<b>Gold Coast's</b><br>most trusted local plumber"}
        desc={"Dependable plumbing professionals trusted by Gold Coast residents. Rely on us to resolve all your domestic and commercial plumbing issues promptly and effectively"}
      />
      <Cta />
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />  
      <Section8 />
      <Section7 />
      <Footer />

    </div>
    </>

  )
}

export default Homepage


